















































import {Component, Vue, Watch} from "vue-property-decorator"
  import DatePicker from "@/components/DatePicker.vue"
  import LineGraph from "@/components/Graph/LineGraph.vue"
  import BarGraph from "@/components/Graph/BarGraph.vue"
  import RiseAndFallGraph from "@/components/Graph/RiseAndFallGraph.vue"
  import {vxm} from "@/store"
  import {TokenSummery} from "@/interface"
  import moment from "moment"

  @Component({components: {LineGraph, BarGraph, RiseAndFallGraph, DatePicker}})
  export default class ReportToken extends Vue {

    private start_at: string = ""
    private end_at: string = ""

    get token_summaries(): TokenSummery[] {
      return vxm.report.token_summaries
        .filter((token_summary: TokenSummery) => !(this.start_at && moment.unix(token_summary.date).isBefore(moment(this.start_at, "YYYY-MM-DD"))))
        .filter((token_summary: TokenSummery) => !(this.end_at && moment.unix(token_summary.date).isAfter(moment(this.end_at, "YYYY-MM-DD"))))
        .sort((a, b) => a.date > b.date ? 1 : -1)
    }

    get labels() {
      return this.token_summaries.map(summary => moment.unix(summary.date).format("M/D"))
    }

    get total_datasets() {
      return this.token_summaries.map(summary => summary.total)
    }

    get rise_and_fall_datasets() {
      return [
        {
          type           : "bar",
          label          : "Increase",
          borderColor    : "rgba(68, 209, 229, 1)",
          backgroundColor: "rgba(68, 209, 229, 0.5)",
          data           : this.token_summaries.map(summary => summary.increase)
        }, {
          type           : "bar",
          label          : "Decrease",
          borderColor    : "rgb(229,68,100)",
          backgroundColor: "rgba(229,68,100, 0.5)",
          data           : this.token_summaries.map(summary => summary.decrease * -1)
        }
      ]
    }

    created() {
      this.start_at = moment().subtract(3, 'months').format('YYYY-MM-DD')
    }

    async mounted() {
      await vxm.report.fetchTokenSummaries(true)
    }

    @Watch("start_at")
    @Watch("end_at")
    async watchStartAt() {

      // 開始より終了が前だったらスワップ
      if (this.start_at && this.end_at) {
        const start = moment(this.start_at)
          , end     = moment(this.end_at)
        if (start.isValid() && end.isValid() && start.isAfter(end)) {
          this.start_at = end.format("YYYY-MM-DD")
          this.end_at = start.format("YYYY-MM-DD")
        }
      }
    }
  }
